import { Title } from "@mui/icons-material";
import React, {useEffect,useState} from "react";
import useGlobal from "../../store";
import { useHistory } from "react-router-dom";

///OMG This whole thing is just horrendous.  Need to revamp this whole module.

const WhereAmI = (props) => {
	const [currentState, currentActions] = useGlobal();
	const [siteName, setSiteName] = useState(currentState && currentState.site && currentState.site.name)
	const [module, setModule] = useState(props.module || currentState && currentState.currentModule)
	const [title, setTitle] = useState()
	const [subtitle, setSubtitle] = useState()
	const [supertitle, setSupertitle] = useState()

	let history = useHistory();

	const getSiteLink = (site_id) => {
		return "/locations/" + site_id
	}

	const getBuildingLink = (building_id) => {
		return "/buildings/" + building_id
	}

	const getSpaceLink = (space_id) => {
		return "/spaces/" + space_id
	}

	const goToLink = (link) => {
		console.log("Link is " + link)
		history.push(link)
	}

	const buildBreadcrumbDiv = (link, label) => {
		return (
			<div className="breadcrumb" onClick={() => { goToLink(link) }}>{label}</div>
		)
	}
	const buildBreadcrumbs = () => {
		switch(props.context) {
			case "Equipment":
				if (currentState.equipment) {
					let siteName = currentState.equipment.site.name;

					if (currentState.equipment.site.name !== currentState.equipment.location.name) {
						return (
							<div className="breadcrumbs">
								{ buildBreadcrumbDiv(getSiteLink(currentState.equipment.site.site_id), siteName) }
								/ 
								{ currentState.equipment.location.name  } 
							</div>
						)
					} else {
						return buildBreadcrumbDiv(getSiteLink(currentState.equipment.site.site_id), siteName)
					}
				}
			case "Site":
				break;
			case "Building":
				if (currentState.building) {
					return (
						<div className="breadcrumbs">
							{ buildBreadcrumbDiv(getSiteLink(currentState.building.site.site_id), currentState.building.site.name) }
						</div>
					)
				}
			case "Zone":
				if (currentState.zone) {
					if (currentState.zone.spaces && currentState.zone.spaces.length > 0) {
						return buildBreadcrumbDiv(getSiteLink(currentState.zone.spaces[0].site_id), currentState.zone.spaces[0].site_name)
					} 
				}
			case "Space":
				if (currentState.space) {
					console.log(currentState.space)
					return (
						<div className="breadcrumbs">
							{ buildBreadcrumbDiv(getSiteLink(currentState.space.site_id), currentState.space.site_name) } / 
							{ buildBreadcrumbDiv(getBuildingLink(currentState.space.building_id), currentState.space.building_name) } / 
							{ currentState.space.floor_name }
						</div>
					)

					return ;
				}
			default:
				if (currentState.feature && currentState.space) {
					return buildBreadcrumbDiv(getBuildingLink(currentState.space.building_id), currentState.space.building_name) + " / " +
						currentState.space.floor_name + " / " +
						buildBreadcrumbDiv(getSpaceLink(currentState.space.id), currentState.space.name);
				}
		}

		return null;
	}

	useEffect(() => {
		setTitle("Community Energy Labs")
		if (props.context) {
			if (props.action === "add") {
				setTitle("Add New " + props.context)
			} else {
				if (props.context.toLowerCase() === "equipment") {
					if (currentState.equipment)
						setTitle(currentState.equipment.name);
					else {
						if (currentState.space) {
							setTitle(currentState.space.name);
						} else if (currentState.building) {
							setTitle(currentState.building.name);
						} else if (currentState.site) {
							setTitle(currentState.site.name);
						} else if (currentState.zone) {
							setTitle(currentState.zone.name);
						}
					}
				} else if (props.context.toLowerCase() === "building") {
					if (currentState.building) {
						setTitle(currentState.building.name);
					} else {
						setTitle("Community Energy Labs")
					}
				} else if (props.context.toLowerCase() === "space" && currentState.space) 
					setTitle(currentState.space.name);
				else if (props.context.toLowerCase() === "site")
					if (currentState.site) {
                                                let site = currentState.site;
                                                let title = site.name;
                                                if(site.customer_code && site.project_code) {
                                                    title += " (" + site.customer_code + "-" + site.project_code + ")";
                                                }
                                                
						setTitle(title)
					} else setTitle("Community Energy Labs")
					
				else if (props.context.toLowerCase() === "feature" && currentState.feature) 
					setTitle(currentState.feature.name);
				else if (props.context.toLowerCase() === "zone" && currentState.zone) 
					setTitle(currentState.zone.name);
			}
		} 
	
			let subtitle = props.context == 'Equipment' && !currentState.equipment ? "Equipment" :
						props.context == 'Site' && !currentState.site ? "Locations" :
						props.context == 'Building' && !currentState.building ? "Buildings" :
						props.context == 'Building' && currentState.building ? "Building" :
						module == "Location" && currentState.site && currentState.site.address1 ? currentState.site.address1 + ", " + currentState.site.city + " " + currentState.site.state : 
						currentState.feature && currentState.feature.feature_type ? currentState.feature.feature_type : 
						currentState.zone && currentState.zone.brick_zone_type ? currentState.zone.brick_zone_type.replace("_", " ") : 
						currentState.space && currentState.space.brick_space_type ? currentState.space.brick_space_type : 
						currentState.equipment && currentState.equipment.type ? currentState.equipment.type : module;

						subtitle = subtitle && subtitle.replace("_", " ");
			setSubtitle(subtitle);				
	}, [currentState])
	

	useEffect(() => {
		setSiteName(currentState && currentState.site && currentState.site.name);
		setModule(currentState && currentState.currentModule)
	}, [currentState])

    return (
        <div className="where-am-i">
			<div className="super-title">{buildBreadcrumbs()}</div>
            <div className="account-name">{title}</div>
            <div className="sub-module">{subtitle}</div>
        </div>

    )
}

export default WhereAmI;
